import { render, staticRenderFns } from "./cardUser.vue?vue&type=template&id=3948fa68&scoped=true"
import script from "./cardUser.vue?vue&type=script&lang=js"
export * from "./cardUser.vue?vue&type=script&lang=js"
import style0 from "./cardUser.vue?vue&type=style&index=0&id=3948fa68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948fa68",
  null
  
)

export default component.exports